import { createSlice } from "@reduxjs/toolkit"
import { defaultAppTheme } from "../constants/ApplicationConstants";
import { createMuiTheme } from "../utils/AppUtils";

const initialState= {
    user: null,
    theme: defaultAppTheme,
    muiTheme: createMuiTheme(defaultAppTheme.mode, defaultAppTheme.light)
}

const authSlice = createSlice({
    name: "user",
    initialState: initialState,
    extraReducers: (builder) => {
        builder
         .addCase('LOGOUT', (state) => {
            Object.assign(state, initialState);
         })
    },
    reducers:{
        addUserToStore: (state, action) => {
            state.user= action.payload
        },
        addThemeToStore: (state, action) => {
            state.theme= action.payload
        },
        updateMuiThme: (state, action) => {
            state.muiTheme= action.payload
        }
    }
})

export const { addUserToStore, addThemeToStore, updateMuiThme } = authSlice.actions
export default authSlice.reducer